import {specialRequestIcon, editPenIcon} from '@img/index.js'

// `readOnly` = the view page: contact + request text as-is, no pencil. See RouteCard.
export default function SpecialRequestCard({trip, specialRequest, contact, onEditSpecialRequest, specialRequestPolicy = {canEdit: true, blockedReason: null}, readOnly = false}) {
    const passenger = trip?.passenger || {}
    const fullName = contact?.full_name || passenger.full_name
    const email = contact?.email || passenger.email
    const phone = contact?.phone || passenger.phone
    const hasRequest = specialRequest.notes || specialRequest.caringPet || specialRequest.quietRide

    return (
        <div className="bg-white p-5 rounded-(--radius-2xl) flex-1 flex flex-col max-md:w-full">
            {/* Contact info — display only */}
            <div className="flex flex-col gap-2.5 min-w-0 mb-5">
                <div className="text-base"><span className="font-bold">Name:</span> {fullName || '—'}</div>
                <div className="text-base"><span className="font-bold">Email:</span> {email || '—'}</div>
                <div className="text-base"><span className="font-bold">Mobile:</span> {phone || '—'}</div>
            </div>

            {/* Special Request */}
            <div className="bg-(--bg-grey) p-5 rounded-(--radius-2xl) flex flex-col flex-1 min-h-0">
                <h6 className="flex items-center gap-2 text-lg font-semibold mb-3!">
                    <img src={specialRequestIcon} alt="" className="max-h-7"/>
                    Special Request
                </h6>
                <span className="text-md flex-1 min-h-0 max-h-[150px] overflow-y-auto pr-1">
                    {hasRequest ? specialRequest.notes : 'No special request'}
                </span>
                {(specialRequest.caringPet || specialRequest.quietRide) && (
                    <div className="flex flex-wrap gap-x-5 gap-y-1 mt-2 text-md">
                        {specialRequest.caringPet && <span>Caring Pet : Yes</span>}
                        {specialRequest.quietRide && <span>Quiet Ride : Yes</span>}
                    </div>
                )}
                {!readOnly && (
                <div className="flex justify-end mt-4">
                    <div className="relative shrink-0 group">
                        <button type="button" disabled={!specialRequestPolicy.canEdit} onClick={onEditSpecialRequest}
                                className="cursor-pointer w-10 h-10 shrink-0 rounded-full bg-(--text-primary) flex items-center justify-center p-0 border-0 disabled:opacity-50 disabled:cursor-not-allowed">
                            <img src={editPenIcon} alt="Edit"/>
                        </button>
                        {!specialRequestPolicy.canEdit && specialRequestPolicy.blockedReason && (
                            <div className="hidden group-hover:block absolute top-full right-0 mt-3 bg-[#3c393c] text-white rounded-xl p-3 text-center text-sm z-10 w-max max-w-[280px] after:content-[''] after:absolute after:w-0 after:h-0 after:border-l-24 after:border-l-transparent after:border-r-[9px] after:border-r-transparent after:border-b-20 after:border-b-[#3c393c] after:-top-4.75 after:right-7.5">
                                <p className="mb-0!">{specialRequestPolicy.blockedReason}</p>
                            </div>
                        )}
                    </div>
                </div>
                )}
            </div>
        </div>
    )
}
